import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Media from '@components/ui/Media/Media'

import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { FC } from 'react'
import s from './CategoryHero.module.scss'
export type CategoryHeroProps = {
  backgroundImage: MediaWithCropsFragment
  text: string
  height?: number
  textPlacement?: 'Bottom' | 'Center'
  fontColor?: string
}

const CategoryHero: FC<CategoryHeroProps> = ({
  backgroundImage,
  text,
  height = 70,
  textPlacement = 'Bottom',
  fontColor,
}) => {
  return (
    <div
      className={s.root}
      style={{ height: `${height === 0 ? 75 : height}vh` }}
    >
      <Media
        mediaWithCrops={backgroundImage}
        className={s.bg}
        sizes="100vw"
        mediaClassName={s.backgroundImage}
        priority
        disableShopTheLook
      />

      <div
        className={clsx(s.content, { [s.center]: textPlacement === 'Center' })}
        style={
          { '--font-color': fontColor ?? undefined } as React.CSSProperties
        }
      >
        <div className="container padded">
          <div className={s.contentWrapper}>
            <TrustedHtml html={text} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CategoryHero
